<script>
	import { createEventDispatcher } from 'svelte';
	import InputContainer from './InputContainer.svelte';
	import Fa from 'svelte-fa';
  import { faTimes } from '@fortawesome/free-solid-svg-icons';
	
	const dispatch = createEventDispatcher();
	
	export let label = "";
  export let placeholder = "";
  export let suffix = "";
  export let text = "";
  export let textAlign = "left";
  export let inputmode = "text";
  export let pattern = null;
  export let helpText = "";
  export let errorText = "";
  export let clearErrorOnEdit = false;
  export let clearButton = false;
  export let width = undefined;
  export let height = "32px";
	
	let inputId;
  let inputElement;

  const normalColor = "#666";
  const hoverColor = "#333";
  const pressColor = "#111";
  let color = normalColor;

  export function focus() {
    inputElement.focus();
  }

  function onKeydown() {
    if (clearErrorOnEdit) errorText = "";
    dispatch('keydown');
  }
</script>

<InputContainer bind:inputId {label} {helpText} {errorText} {width}>
	<div class="container">
    <input bind:this={inputElement} id={inputId} type="text" {placeholder} bind:value={text} {inputmode} {pattern} style="text-align: {textAlign}; height: {height};" on:focus on:blur on:change on:keydown={onKeydown}>
    <div class="extra">
      {#if suffix}
        <span class="suffix">{suffix}</span>
      {/if}
      {#if clearButton && text}
        <button on:click={() => text = ""} on:mouseenter={() => color = hoverColor} on:mouseleave={() => color = normalColor}
          on:mousedown={() => color = pressColor} on:mouseup={() => color = hoverColor}>
          <Fa icon={faTimes} {color} />
        </button>
      {/if}
    </div>
  </div>
</InputContainer>

<style> 
  .container {
    display: grid;
    grid-template-columns: auto min-content;
  }

  input {
    grid-row-start: 1;
    grid-column: 1 / span 2;
    background-color: white;
    border-color: #ccc;
    border-radius: var(--border-radius);
    outline: none;
    margin: 0;
  }

  input:hover {
    border-color: gray;
  }

  input:focus {
    border-color: var(--primary-color);
  }

  .extra {
    grid-row-start: 1;
    grid-column-start: 2;
    justify-self: center;
    align-self: center;
    z-index: 1;
    padding: 2px 6px;
  }

  .suffix {
    color: #aaa;
    font-size: 14px;
    pointer-events: none;
  }

  button {
    background-color: transparent;
    border: none;
    margin: auto;
    padding: 3px;
    cursor: pointer;
  }

  button:focus {
    background-color: transparent;
  }
	
	::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
		color: #bbb;
		opacity: 1; /* Firefox */
	}

	:-ms-input-placeholder { /* Internet Explorer 10-11 */
		color: #bbb;
	}

	::-ms-input-placeholder { /* Microsoft Edge */
		color: #bbb;
	}
</style>